import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
const benefits = [{
  title: <>
        Terminás tu primera mesa en{' '}
        <span className="underline-green" data-id="element-11">7 días</span>.
      </>,
  desc: <>
        Cada paso numerado. Cada tiempo especificado.{' '}
        <span className="highlight-green" data-id="element-12">Sin improvisar nada</span>.
      </>
}, {
  title: <>Nunca más una burbuja arruina tu trabajo.</>,
  desc: <>
        El capítulo 6 te enseña el{' '}
        <strong className="text-[#16A34A]" data-id="element-13">sellado de poros</strong> que el 90%
        de los tutoriales se saltea.{' '}
        <em className="text-gray-500 block mt-2" data-id="element-14">
          Ese solo paso lo cambia todo.
        </em>
      </>
}, {
  title: <>
        Lográs el{' '}
        <span className="underline-green" data-id="element-15">brillo espejo profesional</span>.
      </>,
  desc: <>
        La secuencia exacta de{' '}
        <strong className="text-[#16A34A]" data-id="element-16">9 grados</strong>
        de lija más <strong className="text-[#16A34A]" data-id="element-17">3 etapas</strong> de
        pulido.
        <em className="text-gray-500 block mt-2" data-id="element-18">
          Sin adivinar, sin experimentar.
        </em>
      </>
}, {
  title: <>
        Dominás{' '}
        <span className="underline-green" data-id="element-19">5 efectos visuales premium</span>.
      </>,
  desc: <>
        Océano, galaxia, mármol, lava y geoda.{' '}
        <span className="highlight-green" data-id="element-20">
          Proporciones exactas de pigmento
        </span>{' '}
        y procedimiento paso a paso para cada uno.
      </>
}, {
  title: <>
        Sabés exactamente <span className="underline-green" data-id="element-21">cuánto cobrar</span>
        .
      </>,
  desc: <>
        La <strong className="text-[#16A34A]" data-id="element-22">fórmula de costeo real</strong>.{' '}
        <em className="text-gray-500 block mt-2" data-id="element-23">
          Sin regalar el trabajo ni cobrar a ojo.
        </em>
      </>
}, {
  title: <>Resolvés cualquier error sin perder la mesa.</>,
  desc: <>
        Los 8 problemas más comunes con su{' '}
        <span className="highlight-green" data-id="element-24">solución completa</span> en el
        capítulo 14.
      </>
}, {
  title: <>Todo con materiales que comprás en Uruguay.</>,
  desc: <>
        <strong className="text-[#16A34A]" data-id="element-25">Proveedores reales</strong>, precios
        en pesos, nombres exactos.{' '}
        <em className="text-gray-500 block mt-2" data-id="element-26">
          Sin importaciones ni búsquedas interminables.
        </em>
      </>
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BenefitsSection() {
  return <section className="py-[56px] md:py-[80px] px-5 relative bg-[#FFFFFF]" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-29">
          <h2 className="text-title-section font-bold text-[#1A3A5C] mb-6 flex items-center justify-center gap-4" data-id="element-30">
            <SparklesIcon className="w-8 h-8 text-[#C9A84C]" data-id="element-31" />
            ESTO ES LO QUE LOGRÁS
          </h2>
          <div className="w-24 h-1 bg-[#C9A84C]/30 mx-auto mt-6" data-id="element-32"></div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-subtitle text-gray-600 text-center mb-12 italic leading-relaxed" data-id="element-33">
          Con Mesas Epoxi Pro, cada uno de estos problemas tiene solución:
        </motion.p>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="flex flex-col gap-[20px]" data-id="element-34">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="card-light border-t-[4px] border-t-[#C9A84C] px-[24px] py-[28px] hover:-translate-y-[4px] hover:shadow-md transition-all duration-300 w-full" data-id="element-35">
              <div className="flex flex-col md:flex-row items-start gap-5" data-id="element-36">
                <div className="w-[34px] h-[34px] rounded-full bg-[#C9A84C] flex items-center justify-center text-[#0F2340] font-bold text-lg shrink-0 mb-4 md:mb-0" data-id="element-37">
                  {index + 1}
                </div>
                <div className="space-y-3" data-id="element-38">
                  <h3 className="text-xl md:text-2xl font-bold text-[#15803D] font-heading leading-tight" data-id="element-39">
                    {benefit.title}
                  </h3>
                  <p className="text-body-main text-gray-700 leading-relaxed" data-id="element-40">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}